import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    maxHeight: 550,
    padding: '10px 20px',
    borderRadius: '10px 0 10px 10px',
    boxShadow: '0 0 2px #888',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]: { padding: '10px 0', maxHeight: 500 }
  },
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 8fr 2fr',
    color: 'gray',
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 6fr 2fr'
    }
  },
  tableHeader: { textAlign: 'left' },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    height: 50,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset'
  },
  tableRowRootWithCursor: {
    cursor: 'pointer'
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 6fr 8fr 1fr',
    gridGap: 20,
    height: 60,
    marginBottom: 4,
    alignItems: 'center',
    width: '100%',
    textAlign: 'unset',
    color: `${theme.palette.text.secondary} !important`,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '8fr 6fr 2fr'
    }
  },
  tableItem: {
    color: 'inherit',
    textAlign: 'left',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },
  nameCell: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  circularIcon: {
    position: 'absolute',
    right: '50%'
  },
  menuItem: {
    width: '100%'
  },
  menuItemRoot: {
    cursor: 'not-allowed'
  }
}))

export default useStyles
